import "reflect-metadata";
import { Container,  decorate, injectable, inject  } from "inversify";
import { ApiSettings } from '../application/ApiSettings';

import { IInternalAuth } from "../interfaces/inversifyDi";
import InternalAuth from '../services/InternalAuth';

// Thrive shared
import { HttpResponseHandler } from "@/application/HttpResponseHandler";

import { IApiSettings, IHttpRequest, IHttpResponseHandler, IExternalAuth } from '@/interfaces/IHttp';

import { AxiosHttp } from '@/application/AxiosHttp'

import { OAuth } from "@/application/OAuth";

const TYPES = {
    IHttpRequest: Symbol.for("IHttpRequest"),
    IExternalAuth : Symbol.for("IExternalAuth"),
    IApiSettings: Symbol.for("IApiSettings"),
    IHttpResponseHandler: Symbol.for("IHttpResponseHandler"),
    ILocalstrings : Symbol.for("ILocalstrings"),
    IInternalAuth : Symbol.for("IInternalAuth"),
    IYourWorkspaces : Symbol.for("IYourWorkspaces"),
};


decorate(injectable(), AxiosHttp);
decorate(inject(TYPES.IApiSettings), AxiosHttp, 0);
decorate(inject(TYPES.IHttpResponseHandler), AxiosHttp, 1);
decorate(inject(TYPES.IExternalAuth), AxiosHttp, 2);

decorate(injectable(), OAuth);
decorate(inject(TYPES.IApiSettings), OAuth, 0);


const container = new Container();
container.bind<IHttpRequest>(TYPES.IHttpRequest).to(AxiosHttp).inTransientScope();
container.bind<IExternalAuth>(TYPES.IExternalAuth).to(OAuth).inSingletonScope();
container.bind<IApiSettings>(TYPES.IApiSettings).to(ApiSettings).inSingletonScope();
container.bind<IHttpResponseHandler>(TYPES.IHttpResponseHandler).to(HttpResponseHandler).inSingletonScope();
container.bind<IInternalAuth>(TYPES.IInternalAuth).to(InternalAuth).inSingletonScope();

export { container, TYPES };